import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getDiscussionMessages: {
        url: `${BASE_PATH_API}/discussions/:id/messages`,
        method: 'GET'
    },
    deleteDiscussionMessage: {
        url: `${BASE_PATH_API}/discussions/:topicId/messages/:postId`,
        method: 'DELETE'
    },
    deleteDiscussion: {
        url: `${BASE_PATH_API}/discussions/:id`,
        method: 'DELETE'
    },
    saveDiscussionMessage: {
        url: `${BASE_PATH_API}/discussions/messages`,
        method: 'POST'
    },
    getDiscussions: {
        url: `${BASE_PATH_API}/discussions`,
        method: 'GET',
        params: {
            '$count': true
        }
    },
    addDiscussion: {
        url: `${BASE_PATH_API}/discussions`,
        method: 'POST'
    }
};

export function DiscussionMessagesApi() {
    return createActions(actions);
}
